export const hardCodedContent = {
    "Loading": {
        "en": "Loading, Please Wait...",
        "es419": "Cargando por favor espere..."
    },
    "Yes": {
        "en": "Yes",
        "es419": "Sí"
    },
    "No": {
        "en": "No",
        "es419": "No"
    },
    "PagerPageText": {
        "en": "Page",
        "es419": "Página"
    },
    "PagerPageOfText": {
        "en": "of",
        "es419": "de"
    },
    "GridNoRecord": {
        "en": "No records to display.",
        "es419": "No hay registros que mostrar."
    },
    "FirstName": {
        "en": "First Name",
        "es419": "Nombre de pila"
    },
    "LastName": {
        "en": "Last Name",
        "es419": "Apellido"
    },
    "FormBuilderUploadFormElementFileTypesSupport": {
        "en": "Only image files are supported jpg, jpeg, and png",
        "es419": "Solo se admiten archivos de imagen jpg, jpeg y png"
    },
    "SignatureError": {
        "en": "Enter name as shown above.",
        "es419": "Ingrese el nombre como se muestra arriba."
    },
    "EmailError": {
        "en": "The emails don’t match. Please enter the same email address in both fields.",
        "es419": "Los correos electrónicos no coinciden. Introduzca la misma dirección de correo electrónico en ambos campos."
    },
    "PwFieldNotValid": {
        "en": "The Password field is invalid.",
        "es419": "El campo Contraseña no es válido."
    },
    "PwFieldDoNotMatch": {
        "en": "Password Values Do Not Match",
        "es419": "Los valores de contraseña no coinciden"
    }
}